/*
  Individuelle Abteilungen — die Gegenstelle zu databases/department_resolution.py.

  Ein Eintrag trägt seine Abteilung entweder als Stammdatensatz oder, wenn sie
  individuell ist, als freien Namen nur für diesen Eintrag. Der Server liefert
  den Namen in beiden Fällen im selben Feld (`department`); `customDepartmentName`
  sagt, dass dahinter kein Stammdatensatz steht.

  Im Raster fallen alle individuellen Abteilungen in eine gemeinsame Zeile —
  eine Zeile je Einzelfall wäre eine Liste, die mit jedem Sonderfall wächst.
*/

export const CUSTOM_DEPARTMENT_ROW_ID = "__custom_department__";
export const CUSTOM_DEPARTMENT_ROW_LABEL = "Individuell";
export const CUSTOM_DEPARTMENT_OPTION_LABEL = "+ Individuelle Abteilung";

/*
  Ein Grau für alles Individuelle — eigene Schichten wie eigene Abteilungen.
  Sie sollen sich von den gepflegten Farben abheben; eine Vorlagen- oder
  Abteilungsfarbe wäre irreführend, dahinter steht kein Stammdatensatz.

  Der Wert ist der DS-Ton neutral-600, als Hex ausgeschrieben: PDF und Excel
  können keine CSS-Variablen lesen — dieselbe Begründung wie in
  features/export/exportColors.js. Das Design-System selbst bleibt unangetastet.
*/
export const INDIVIDUAL_COLOR = "#96a1b3";

/** Trägt der Eintrag einen eigenen Namen — als Schicht oder als Abteilung? */
export function isIndividualEntry(entry) {
  return entry?.entryType === "custom_shift" || isCustomDepartmentEntry(entry);
}

function asText(value) {
  return String(value ?? "").trim();
}

export function getCustomDepartmentName(entry) {
  return asText(entry?.customDepartmentName);
}

export function isCustomDepartmentEntry(entry) {
  return Boolean(getCustomDepartmentName(entry));
}

/** Der anzuzeigende Abteilungsname — individuell oder aus den Stammdaten. */
export function getDepartmentName(entry) {
  return getCustomDepartmentName(entry) || asText(entry?.department);
}

/**
 * Die Abteilungsfelder für einen API-Aufruf.
 *
 * Getrennte Felder, weil der Server `department_name` gegen die Stammdaten
 * auflöst: ein individueller Name käme dort nicht an, der Eintrag verlöre
 * seine Abteilung stillschweigend.
 */
export function buildDepartmentPayload(name, isCustom) {
  const department = asText(name);
  if (isCustom && department) {
    return { department_name: null, custom_department_name: department };
  }
  return { department_name: department || null, custom_department_name: null };
}

